import React, { createContext, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const ChatContext = createContext();

const ChatProvider = ({ children }) => {
  const [selectedChat, setSelectedChat] = useState(null);
  const [user, setUser] = useState(null);
  const [notification, setNotification] = useState([]);
  const [chats, setChats] = useState(null);
  const [presenceMap, setPresenceMap] = useState({});
  const [blockedIds, setBlockedIds] = useState([]);
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem("meetup-theme") === "light"
        ? "light"
        : "dark";
    } catch {
      return "dark";
    }
  });

  const toggleTheme = () =>
    setTheme((t) => (t === "light" ? "dark" : "light"));

  // The chats UI themes via plain CSS classes (plus portaled Chakra
  // modals/menus), so the flag lives on <body> where everything inherits it.
  useEffect(() => {
    try {
      document.body.classList.toggle("theme-light", theme === "light");
      localStorage.setItem("meetup-theme", theme);
    } catch {
      // storage / DOM unavailable — theme just won't persist
    }
  }, [theme]);

  const history = useHistory();

  useEffect(() => {
    try {
      const stored = localStorage.getItem("userInfo");
      if (!stored) {
        history.push("/");
        return;
      }
      const userInfo = JSON.parse(stored);
      setUser(userInfo);

      if (!userInfo) history.push("/");
    } catch {
      localStorage.removeItem("userInfo");
      setUser(null);
      history.push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <ChatContext.Provider
      value={{
        selectedChat,
        setSelectedChat,
        user,
        setUser,
        notification,
        setNotification,
        chats,
        setChats,
        presenceMap,
        setPresenceMap,
        blockedIds,
        setBlockedIds,
        theme,
        setTheme,
        toggleTheme,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const ChatState = () => {
  return useContext(ChatContext);
};

export default ChatProvider;
